/* How a chain bottom ENDS is record state and stays under the box. An OPEN
 * walk is not a status pill: it is an ACTION — a door into the look-through
 * for that entity, dressed in the DECIDE/WALK stage colour (wine, the walk
 * card it opens — Ale 2026-09-03) so the chip recalls the decision it leads
 * to; gone once the walk is signed off. Still a door, never a red label.
 * Shared by the fan-bar tree and the co-owned DAG. */

import { Link } from 'react-router-dom'
import type { WalkNode } from './fundArea'

/** ``fundId``: the fund page the chip renders inside. The door lands on
 *  the RECORD KEEPING stream scoped to THAT fund (B6 audit 2026-09-03: a
 *  bare link rendered every fund's segments on a multi-fund pilot, and the
 *  officer booked another fund's document believing the chip held). */
export default function WalkChip({ node, fundId }: { node: WalkNode; fundId?: string | null }) {
  if (node.state === 'open')
    return (
      <Link
        className="fa-walkbtn"
        to={`/v2/workbench/record-keeping${fundId ? `?fund=${encodeURIComponent(fundId)}` : ''}`}
        data-testid="walk-door"
      >
        Review look-through in Workbench ›
      </Link>
    )
  if (node.state === 'stopped')
    return (
      <span className="fa-tstate t-stop" data-testid="walk-chip-stop">
        ends here — {node.reason_label?.toLowerCase()}
      </span>
    )
  if (node.state === 'by_rule')
    return (
      <span className="fa-tstate t-rule" data-testid="walk-chip-rule">
        ends by rule — {node.rule_label}
      </span>
    )
  return null
}
